/**
 * Sets up polyfill for css objectfit
 * Polyfillscript is included in vendors bundle
 * 
 * See (https://github.com/bfred-it/object-fit-images)
 */

export class ObjectFitModule {

    constructor() {
        objectFitImages();
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/App/ObjectFitModule.js